// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/efis-principles.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/efis-principles/efis-limits.js';
import g1 from '../lessons/aeronautics/efis-principles/efis-principles.js';

mount([g0, g1]);
